// extracted by mini-css-extract-plugin
export default {"form":"q4cehvJC8qVd2w19u540pA=="};